import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer1WycinkaKlasyczna() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/wycinka-klasyczna-1.jpeg"
          alt="Wycinka klasyczna drzew - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Wycinka drzew z działek pod budowę i inwestycje Gdańsk, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Profesjonalne ścinanie drzew metodą tradycyjną na Pomorzu
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Przygotowujesz działkę pod budowę domu na terenie Gdańska, Gdyni, Kartuz lub Wejherowa i musisz usunąć kolidujące drzewa? Świadczymy usługi profesjonalnej wycinki drzew metodą klasyczną z pełnym zabezpieczeniem terenu. Pozyskane drewno tniemy na wymiar, a gałęzie rozdrabniamy lub wywozimy, przygotowując grunt pod dalsze <a href="/oczyszczanie-terenu/niewelacja-terenu" className="underline hover:opacity-80">równanie terenu</a>.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Wycinka drzew na terenach prywatnych i budowlanych
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Usuwanie drzew z działki przed rozpoczęciem prac
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Oczyszczenie terenu po wycince drzew
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Kiedy konieczne jest wycięcie drzewa
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Powody, dla których możesz usunąć drzewo
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie wycinamy drzewa – nasz obszar działania
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Wycinka drzew – cennik
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Wycinka drzew na terenach prywatnych i budowlanych</h2>
          <p>
            Metoda klasyczna to wycięcie drzewa piłą łańcuchową od dołu, czyli z
            poziomu gruntu. Taka metoda sprawdzi się, jeśli wokół drzewa jest
            dużo miejsca. Doświadczony drwal potrafi tak wyciąć drzewo, by
            przewróciło się w odpowiednim kierunku.
          </p>

          <h2 id="2">Usuwanie drzew z działki przed rozpoczęciem prac</h2>
          <p>
            Usuwanie drzew we własnym zakresie może być niebezpieczne. Piła może
            zakleszczyć się w pniu, jeśli będzie źle użyta. Pień może obalić się
            w niekontrolowany sposób, co może uszkodzić i zniszczyć rzeczy, na
            które upadnie. Jest to też groźne dla zdrowia, a nawet życia osób,
            które znajdują się w pobliżu.
          </p>
          <p>
            O wiele lepiej jest zlecić to nam. Posiadamy fachowców, którzy
            zawodowo zajmują się wycinką drzew. Potrafimy ocenić, które drzewa
            można wyciąć z poziomu gruntu bez szkód dla otoczenia. Jest to
            szybsze niż wycinka metodą alpinistyczną. Jednak nie wszystkie
            drzewa można usunąć w ten sposób. Czasami jedynym wyjściem jest
            metoda alpinistyczna, która też jest w naszej ofercie.
          </p>

          <h2 id="3">Oczyszczenie terenu po wycince drzew</h2>
          <p>
            Niektóre drzewa można wyciąć bez zezwolenia. Ważny jest obwód pnia
            mierzony na wysokości 5 cm od poziomu gruntu. Dla różnych gatunków
            drzew są inne dozwolone wartości. Nie musisz się na tym znać.
            Posiadamy w ekipie dendrologa, który się tym zajmie.
          </p>
          <p>
            Wycinka drzew w okresie lęgowym ptaków nie zawsze jest możliwa. Na
            szczęście nie musisz się tym martwić. Zatrudniamy ornitologa, który
            sprawdzi, czy na drzewie nie ma gniazd gatunków chronionych. To
            wszystko będzie niezbędne do uzyskania pozwolenia na wycinkę.
          </p>

          <h2 id="4">Kiedy konieczne jest wycięcie drzewa</h2>
          <p>
            Czasami drzewo przestaje być miłym towarzyszem w ogrodzie, a staje
            się zagrożeniem. W takiej sytuacji nie ma co zwlekać. Trzeba podjąć
            zdecydowane kroki i zlecić wycięcie drzewa.
          </p>

          <h3 id="5">Powody, dla których możesz usunąć drzewo:</h3>
          <ul>
            <li>drzewo jest martwe</li>
            <li>drzewo jest chore</li>
            <li>drzewo jest uszkodzone po burzy</li>
            <li>drzewo zasłania widok</li>
            <li>drzewo jest niebezpiecznie pochylone</li>
            <li>drzewo rośnie zbyt blisko zabudowań</li>
            <li>drzewo będzie przeszkadzać w budowie</li>
          </ul>
          <p>
            Oczywiście powodów może być znacznie więcej. My nie będziemy się o
            nie pytać. Jeśli chcesz pozbyć się drzewa, to pokaż, o które drzewo
            chodzi, a my zajmiemy się resztą.
          </p>

          <h2 id="6">Gdzie wycinamy drzewa – nasz obszar działania</h2>
          <p>
            Obsługujemy zarówno osoby prywatne, jak i klientów
            instytucjonalnych. Jeśli potrzebna jest Ci wycinka drzew, pomorskie
            to region, w którym działamy. Usuwamy drzewa w Trójmieście i
            okolicach, ale nasze usługi oferujemy też na całym Pomorzu.
          </p>

          <h2 id="7">Wycinka drzew – cennik</h2>
          <p>
            Każde drzewo jest inne, więc cena zależy od paru czynników. Będziemy
            potrzebować od Ciebie kilku informacji, żeby móc podać cenę za naszą
            usługę. Dobrym źródłem informacji będzie zdjęcie drzewa do wycięcia.
            Wyślij je nam. Dzięki temu szybciej będziemy mogli określić koszt
            usługi. Jeśli będziemy mieć za mało danych, to umówimy się na
            bezpłatną wizytę, żeby móc Ci podać dokładną cenę.
          </p>
          <p>
            Jeśli masz drzewo do wycięcia to nie czekaj – działaj już dziś. Nie
            pozwól, żeby wichura je przewróciła. Zamów bezpłatną wycenę, a my
            uwolnimy Cię od Twojego problemu. Zajmiemy się wycinką od A do Z, od
            uzyskania pozwolenia po uprzątnięcie pozostałości po wycince.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/wycinka-klasyczna-2.jpeg"
              alt="Wycinka klasyczna drzew - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/wycinka-klasyczna-3.jpeg"
              alt="Wycinka klasyczna drzew - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/wycinka-klasyczna-4.jpeg"
              alt="Wycinka klasyczna drzew - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/wycinka-klasyczna-5.jpeg"
              alt="Wycinka klasyczna drzew - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/wycinka-klasyczna-6.jpeg"
              alt="Wycinka klasyczna drzew - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/wycinka-klasycznawycinka-drzew-1.jpeg"
              alt="Wycinka drzew - realizacja Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/wycinka-klasycznawycinka-drzew-2.jpeg"
              alt="Wycinka drzew - realizacja Drzewus nr 7"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/wycinka-klasycznawycinka-drzew-3.jpeg"
              alt="Wycinka drzew - realizacja Drzewus nr 8"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer1WycinkaKlasyczna;